import { SvgIcon, SvgIconProps } from "@mui/material";

export const BellIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M14 20.003a2.5 2.5 0 0 1-4 0M5.997 12.482V8.999A6.003 6.003 0 0 1 12 2.996v0A6.002 6.002 0 0 1 18.003 9v3.483h-.005l1.377 1.378a2.134 2.134 0 0 1-1.51 3.642H6.134a2.134 2.134 0 0 1-1.51-3.642l1.377-1.378"
      />
    </svg>
  </SvgIcon>
);
